'use client';

import { Container, Box } from "@mui/material";
import Header from "@/app/components/Header/Header";
import LoadingBar from "./LoadingBar";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "../lib/msalConfig";

export default function ClientLayout({
  children,
}: {
  children: React.ReactNode;
}) {

  return (
    <MsalProvider instance={msalInstance}>
      <Header />
      <LoadingBar />
      <Container maxWidth="xl">
        <Box sx={{ my: 4 }}>
          {children}
        </Box>
      </Container>
    </MsalProvider>
  );
}